
<div class="about-dip-container">
  <div class="absolute-watermark absolute-watermark--chart">
    <svg-icon
      src="assets/icons/watermark-chart.svg"
      [svgStyle]="{ 'width.px':685 }"
    ></svg-icon>
  </div>
  <div class="absolute-watermark absolute-watermark--dots">
    <svg-icon
      src="assets/icons/watermark-dots.svg"
      [svgStyle]="{ 'width.px':494 }"
    ></svg-icon>
  </div>
  <div class="absolute-watermark absolute-watermark--time">
    <svg-icon
      src="assets/icons/watermark-time.svg"
      [svgStyle]="{ 'width.px':388 }"
    ></svg-icon>
  </div>
  <div class="absolute-watermark absolute-watermark--chart-two">
    <svg-icon
      src="assets/icons/watermark-chart-2.svg"
      [svgStyle]="{ 'width.px':468 }"
    ></svg-icon>
  </div>
  <div class="absolute-watermark absolute-watermark--dots-two">
    <svg-icon
      src="assets/icons/watermark-dots.svg"
      [svgStyle]="{ 'width.px':664 }"
    ></svg-icon>
  </div>
  <div class="about-dip-header">
    <div class="about-dip-header-bg"></div>
    <div class="dip-icon-container">
      <svg-icon
        class="dip-icon dip-icon--xs-phone"
        src="assets/icons/dip.svg"
        [svgStyle]="{ 'width.px':120 }"
      ></svg-icon>
      <svg-icon
        class="dip-icon dip-icon--phone-dip-icon"
        src="assets/icons/dip.svg"
        [svgStyle]="{ 'width.px':185 }"
      ></svg-icon>
      <svg-icon
        class="dip-icon dip-icon--desktop-dip-icon"
        src="assets/icons/dip.svg"
        [svgStyle]="{ 'width.px':220 }"
      ></svg-icon>
      <svg-icon
        class="dip-icon dip-icon--desktop-xl-dip-icon"
        src="assets/icons/dip.svg"
        [svgStyle]="{ 'width.px':360 }"
      ></svg-icon>
    </div>

    <div class="header-bottom">
      <div class="button-container button-container--new">
        <libero-button
          (click)="clickIWantDip()"
          label="{{ 'aboutDip.iWantDip' | translate }}"
          btnClasses="btn--primary btn--big"
          data-cy="i-want-dip-button-1"
        ></libero-button>
      </div>

      <div class="header-bottom-background">
        <div class="button-container button-container--summary">
          <libero-button
            routerLink="/summary" fragment="{{investmentFragmentId}}"
            label="{{ 'aboutDip.myInvestments' | translate }}"
            btnClasses="btn--primary btn--big"
            data-cy="dip-summary-link-1"
          ></libero-button>
        </div>

        <div class="header-bottom-desc">
          <div class="desc-header" [innerHTML]="'aboutDip.headerDescHeading' | translate"></div>
          <p>{{ 'aboutDip.headerDesc' | translate }}</p>
        </div>

      </div>
    </div>

    <div class="header-bottom-desktop">
      <div class="left-column">
        <div class="desc-header-desktop" [innerHTML]="('aboutDip.headerDescHeading' | translate) + ' ' + ('aboutDip.headerDesc' | translate)"></div>
        <p class="dip-description-desktop" [innerHTML]="'aboutDip.dipDescription' | translate"></p>
      </div>


      <div class="desktop-buttons-container">
        <libero-button
          (click)="clickIWantDip()"
          label="{{ 'aboutDip.iWantDip' | translate }}"
          btnClasses="btn--primary btn--big"
          data-cy="i-want-dip-button-2"
        ></libero-button>
        <libero-button
          routerLink="/summary" fragment="{{investmentFragmentId}}"
          label="{{ 'aboutDip.myInvestments' | translate }}"
          btnClasses="btn--primary btn--big"
          data-cy="dip-summary-link-2"
        ></libero-button>
      </div>
    </div>
  </div>

  <p class="dip-description" [innerHTML]="'aboutDip.dipDescription' | translate"></p>

  <div class="cards-header">
    {{ 'aboutDip.cardsHeader' | translate }}
  </div>


  <div class="advantage-cards-container">
    @for (advantage of dipAdvantages; track advantage) {
      <libero-dip-advantage-card advantageId="{{advantage}}"></libero-dip-advantage-card>
    }
  </div>

  <div class="secondary-bg">
    <div class="desktop-conditions-container">
      <div class="desktop-conditions-layout">
        <div class="how-to-header">
          {{ 'aboutDip.howToHeader' | translate }}
        </div>

        <div class="how-to-conditions">
          {{ 'aboutDip.govConditions' | translate }}
        </div>

        <div class="conditions-container">
          <div class="condition">
            <div class="condition-bg">
              <div class="condition-number">
                1
              </div>
            </div>
            <div class="condition-description">
              {{ 'aboutDip.condition1' | translate }}
            </div>
          </div>
          <div class="condition">
            <div class="condition-bg">
              <div class="condition-number">
                2
              </div>
            </div>
            <div class="condition-description">
              {{ 'aboutDip.condition2' | translate }}
            </div>
          </div>
        </div>

        <div class="withdraw-desc">
          {{ 'aboutDip.withdrawDescription' | translate }}
        </div>
      </div>

      <div class="pension-desc-container">
        <div class="pension-header">
          {{ 'aboutDip.pensionHeader' | translate }}
        </div>
        <div class="pension-desc" [innerHTML]="'aboutDip.pensionDescription' | translate"></div>
      </div>
    </div>
  </div>

  <div class="create-dip-container">
    <div class="create-dip-header">
      {{ 'aboutDip.createDipHeader' | translate }}
    </div>
    <div class="create-dip-desc">
      {{ 'aboutDip.createDipDesc' | translate }}
    </div>
    <div class="create-dip-encouragement">
      {{ 'aboutDip.createEncouragement' | translate}}
    </div>

    <div class="create-buttons-container">
      <libero-button
        (click)="clickIWantDip()"
        label="{{ 'aboutDip.iWantDip' | translate }}"
        btnClasses="btn--primary btn--big"
        data-cy="i-want-dip-button-3"
      ></libero-button>

      <div class="create-summary-button-container">
        <libero-button
          routerLink="/summary" fragment="{{investmentFragmentId}}"
          label="{{ 'aboutDip.myInvestments' | translate }}"
          btnClasses="btn--primary btn--big"
          data-cy="dip-summary-link-3"
        ></libero-button>
      </div>
    </div>
  </div>

  <div class="table-footer-container">
    <div class="table-header">
      {{ 'aboutDip.tableHeader' | translate }}
    </div>
    <div class="table-desc" [innerHTML]="'aboutDip.tableDesc' | translate"></div>

    <div class="table-container">
      <div class="table-arrow-container">
        <svg-icon
          src="assets/icons/double-arrow.svg"
          [svgStyle]="{ 'width.px':29 }"
        ></svg-icon>
      </div>
      <table class="dip-table">
        <tr>
          <th>
            <!-- empty -->
          </th>
          <th>
            {{ 'aboutDip.table.th1' | translate }}
          </th>
          <th>
            {{ 'aboutDip.table.th2' | translate }}
          </th>
          <th>
            {{ 'aboutDip.table.th3' | translate }}
          </th>
        </tr>
        <tr>
          <td class="description-col">
            {{ 'aboutDip.table.tr1.desc' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr1.value1' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr1.value2' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr1.value3' | translate }}
          </td>
        </tr>
        <tr>
          <td class="description-col">
            {{ 'aboutDip.table.tr2.desc' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr2.value1' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr2.value2' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr2.value3' | translate }}
          </td>
        </tr>
        <tr>
          <td class="description-col">
            {{ 'aboutDip.table.tr3.desc' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr3.value1' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr3.value2' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr3.value3' | translate }}
          </td>
        </tr>
        <tr class="evaluation-row">
          <td class="description-col">
            {{ 'aboutDip.table.tr4.desc' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr4.value1' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr4.value2' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.tr4.value3' | translate }}
          </td>
        </tr>
        <tr class="summary-table-row">
          <td class="description-col desc">
            {{ 'aboutDip.table.trSummary.desc' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.trSummary.value1' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.trSummary.value2' | translate }}
          </td>
          <td>
            {{ 'aboutDip.table.trSummary.value3' | translate }}
          </td>
        </tr>
      </table>
    </div>

    <div class="star-explains">
      <p>{{ 'aboutDip.tableStar1' | translate }}</p>
      <p [innerHTML]="'aboutDip.tableStar2' | translate"></p>
    </div>
  </div>

  <div class="dip-summary-padding">
    <div class="dip-summary-container">
      <div class="summary-arrow-container">
        <svg-icon
          src="assets/icons/double-arrow.svg"
          [svgStyle]="{ 'width.px':29 }"
        ></svg-icon>
      </div>
      <div class="summary-col">
        <div class="summary-text">
          {{ 'aboutDip.summaryCol1.row1' | translate }}
        </div>
        <div class="summary-highlighted">
          {{ 'aboutDip.summaryCol1.row2' | translate }}
        </div>
      </div>
      <div class="summary-col summary-col--margin">
        <div class="summary-text">
          {{ 'aboutDip.summaryCol2.row1' | translate }}
        </div>
        <div class="summary-highlighted">
          {{ 'aboutDip.summaryCol2.row2' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>